var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandDefaultIcon24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h26v26H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#brand_default_icon_24x24_svg__a)",
  fill: "#BFC6CE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.003 13.732c-.46 0-.919.293-1.166.599-.73.846-1.708 1.516-3.004 1.516-2.014 0-3.545-1.634-3.545-3.502 0-1.868 1.531-3.502 3.545-3.502 1.284 0 2.262.67 3.004 1.516.247.306.707.6 1.166.6.848 0 1.426-.635 1.426-1.34 0-.27-.06-.576-.236-.834C18.039 7.093 16.177 6 13.833 6c-3.604 0-6.42 2.785-6.42 6.345 0 3.56 2.816 6.345 6.42 6.345 2.32 0 4.194-1.081 5.36-2.785.177-.258.236-.552.236-.834 0-.693-.59-1.34-1.426-1.34ZM7.414 20.1c.78 0 1.413-.631 1.413-1.41 0-.779-.633-1.41-1.413-1.41-.781 0-1.414.631-1.414 1.41 0 .779.633 1.41 1.414 1.41Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "brand_default_icon_24x24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(6 6)",
  d: "M0 0h13.429v14.1H0z"
})))));
export default SvgBrandDefaultIcon24X24;